module.exports = __webpack_public_path__ + "static/media/vegitables_12.06e2ebea.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_12.csv
// module id = 594
// module chunks = 0